// @flow strict
import { boolean, object, string } from 'yup'
import { type FormState, type MoreInformationRequest } from './formTypes'
const REQUIRED_FIELD_MESSAGE = 'This field is required'

export const businessMoreInformationFormSchema = object().shape({
  userName: string().required(REQUIRED_FIELD_MESSAGE),
  userEmail: string()
    .email('Please enter a valid email')
    .required(REQUIRED_FIELD_MESSAGE),
  businessName: string(),
  businessIndustry: string().required(REQUIRED_FIELD_MESSAGE),
  businessType: string().required(REQUIRED_FIELD_MESSAGE),
  privacy: boolean().oneOf([true], REQUIRED_FIELD_MESSAGE),
})

export const formStateToMoreInformationRequest = (
  form: FormState,
): MoreInformationRequest => {
  return {
    user_name: form.userName,
    email: form.userEmail,
    business_name: form.businessName,
    industry: form.businessIndustry,
    type: form.businessType,
    companies_house_registration_number: form.companiesHouseRegistrationNumber,
    message: form.message,
    opt_in: form.privacy,
  }
}
